// OrderSummary.jsx
export default function OrderSummary({ chocolate, vanilla, total }) {
  const totalQty = chocolate + vanilla;

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-2xl shadow-lg text-sm mt-6 sticky top-6">
      <h4 className="text-lg font-bold mb-2 text-pink-600 dark:text-pink-300">🧾 Order Summary</h4>
      <ul className="mb-2 space-y-1">
        {chocolate > 0 && (
          <li>
            🍫 <strong>Chocolate:</strong> {chocolate}
          </li>
        )}
        {vanilla > 0 && (
          <li>
            🍦 <strong>Vanilla:</strong> {vanilla}
          </li>
        )}
      </ul>
      <p>
        🧮 <strong>Total:</strong> {totalQty} donut{totalQty !== 1 ? 's' : ''}
      </p>
      <p>
        💵 <strong>Price:</strong> ${total.toFixed(2)}
      </p>
    </div>
  );
}
